import { render, staticRenderFns } from "./HomeLicensing.vue?vue&type=template&id=06743947&scoped=true&"
import script from "./HomeLicensing.vue?vue&type=script&lang=js&"
export * from "./HomeLicensing.vue?vue&type=script&lang=js&"
import style0 from "./HomeLicensing.vue?vue&type=style&index=0&id=06743947&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06743947",
  null
  
)

export default component.exports